/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "vertical",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true place Component's label above its value."
    },
    {
        name: "hint",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "If provided will add a hint text to the Component."
    },
    {
        name: "discreteHint",
        type: "Boolean",
        defaultValue: "true",
        isRequired: "false",
        description:
            "Discrete hints are displayed in label info icon, non-discrete hints - below value container."
    },
    {
        name: "label",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The label of the Component. If omitted will be visualized empty."
    },
    {
        name: "skipLabel",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true will disregard the value of label and will not display label at all."
    },
    {
        name: "valueWidth",
        type: "Number",
        defaultValue: "50",
        isRequired: "false",
        description: "A number representing width percent to be set to the value container."
    },
    {
        name: "labelWidth",
        type: "Number",
        defaultValue: "50",
        isRequired: "false",
        description: "A number representing width percent to be set to the label container."
    },
    {
        name: "tooltipMaxWidth",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Sets the hint's tooltip's maxWidth in pixels."
    },
    {
        name: "tooltipContainerClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Add classnames to the tooltip's container"
    },
    {
        name: "labelAlignment",
        type: "['left','center','right']",
        defaultValue: "left",
        isRequired: "false",
        description: "Determines the alignment of the label's text within its width."
    },
    {
        name: "dataTqId",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "If provided is added as data-tq-id attribute in the most outer div. Used for testing."
    },
    {
        name: "disabled",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true will display the Component in its disabled state."
    }
];

export default documentedProperties;
